module.exports = __webpack_public_path__ + "img/3D数据扫描2.65ec33e7.gif";